import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IExperiment } from '../model/experiment/Experiment';
import type { IExperimentSearchParams } from '../api/requests/ExperimentApiGateway';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useDistributedExperimentsResult {
    isLoaded: boolean;
    experiments: IExperiment[];
}

export const useFindExperiments = (searchParams: IExperimentSearchParams) => {
    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();

    const [result, setResult] = useState<useDistributedExperimentsResult>({ isLoaded: false, experiments: [] });

    useEffect(() => {
        setResult({ isLoaded: false, experiments: [] });

        rootStore.experimentStore.findExperiments(searchParams)
            .then((entities) => {
                setResult({ isLoaded: true, experiments: entities });
            })
            .catch(e => publishNotification({
                text: `Error finding experiments: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.experimentStore, publishNotification, searchParams]);

    return result;
};
